/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientNameOut
 */
export interface ClientNameOut {
    /**
     * 
     * @type {string}
     * @memberof ClientNameOut
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ClientNameOut
     */
    clientId: number;
}

export function ClientNameOutFromJSON(json: any): ClientNameOut {
    return ClientNameOutFromJSONTyped(json, false);
}

export function ClientNameOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientNameOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'clientId': json['clientId'],
    };
}

export function ClientNameOutToJSON(value?: ClientNameOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'clientId': value.clientId,
    };
}


